export abstract class PermissionsActionDirective {
	public abstract execute(hasPermission: boolean): void;
}
